import * as React from "react";
import * as Tooltip from "@radix-ui/react-tooltip";

export function APIEndpointInline({ title, path, usecase }) {

    const pathFixed = path.endsWith("/") ? path : path + "/";

    return <Tooltip.Provider>
        <Tooltip.Root delayDuration={300}>
            <Tooltip.Trigger>
                <span className="endpoint-inline"><span className="badge">GET</span> <code>{title}</code>
                </span>
                <style jsx>
                    {`    
            .badge {
                width: 40px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                text-transform: uppercase;
                background-color: rgb(220,252,231);
                color: rgb(22,163,74);
                margin-right: 0px;
                border-radius: 5px;
                font-size: var(--font-size-1);
                padding-right: 5px;
                padding-left: 5px;
                padding-top: 3px;
                padding-bottom: 3px;
            }
`}</style>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content className="tooltip-content">
                    <h3>{title}</h3>
                    <div className="endpoint-inline"><span className="badge">GET</span> <code>{pathFixed}</code></div>
                    <p suppressHydrationWarning={true} className="d">{usecase}</p>
                    <style jsx>
                        {`
                        .endpoint-inline, .d {
                            margin-top: 1rem;
                        }          
                        .badge {
                            width: 40px;
                            height: 16px;
                            line-height: 16px;
                            text-align: center;
                            text-transform: uppercase;
                            background-color: rgb(220,252,231);
                            color: rgb(22,163,74);
                            margin-right: 0px;
                            border-radius: 5px;
                            font-size: var(--font-size-1);
                            padding-right: 5px;
                            padding-left: 5px;
                            padding-top: 3px;
                            padding-bottom: 3px;
                        }              
                        `}
                    </style>
                    <Tooltip.Arrow className="tooltip-arrow" />
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    </Tooltip.Provider>;


    //     return <span className="endpoint-inline"><span className="badge">GET</span> <code>{title}</code>
    //         <style jsx>
    //             {`
    //         .endpoint-inline {
    //             // border: 1px solid var(--code-border);
    //             // border-radius: 0.25rem;
    //         }
    //             .badge {
    //                 width: 40px;
    //                 height: 16px;
    //                 line-height: 16px;
    //                 text-align: center;
    //                 text-transform: uppercase;
    //                 background-color: rgb(220,252,231);
    //                 color: rgb(22,163,74);
    //                 margin-right: 0px;
    //                 border-radius: 5px;
    //                 font-size: 12px;
    //                 padding-right: 5px;
    //                 padding-left: 5px;
    //                 padding-top: 3px;
    //                 padding-bottom: 3px;
    //             }
    // `}</style>
    //     </span>;

    // return <><h3>{title}</h3><div className="endpoint">
    //     <span className="badge">GET</span><code><span>{path}</span></code>
    // </div><div className="endpoint-description">
    //         {description ? <p dangerouslySetInnerHTML={{ __html: description }} /> : null}
    //     </div><style jsx>
    //         {`
    //         .badge {
    //             width: 40px;
    //             height: 16px;
    //             line-height: 16px;
    //             text-align: center;
    //             text-transform: uppercase;
    //             background-color: rgb(220,252,231);
    //             color: rgb(22,163,74);
    //             margin-right: 5px;
    //             border-radius: 5px;
    //             font-size: 12px;
    //             padding-right: 5px;
    //             padding-left: 5px;
    //             padding-top: 3px;
    //             padding-bottom: 3px;
    //         }
    //         .endpoint {
    //             margin-top: 1rem;
    //         }
    //         .endpoint-description {
    //             margin-top: 1rem;
    //         }
    //         .endpoint-description :global(article) {
    //             padding: 0;
    //         }
    //         `}
    //     </style></>;
}
